(function (jQuery) {
  jQuery.gfBorderWidthAll = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.refresh();
    };

    this.refresh = function () {
      const $dad = $element.parents('.columns');
      const $advanced = $dad.next('.columns-advanced');

      const $gfBorderWidth = $advanced.find('.gfBorderWidth');
      const $borderTop = $gfBorderWidth.find('input[name="border-top-width"]');
      const $borderRight = $gfBorderWidth.find('input[name="border-right-width"]');
      const $borderBottom = $gfBorderWidth.find('input[name="border-bottom-width"]');
      const $borderLeft = $gfBorderWidth.find('input[name="border-left-width"]');

      $borderTop
        .add($borderRight)
        .add($borderBottom)
        .add($borderLeft)
        .on('value-change', function () {
          const borderTopVal = $borderTop.attr('value');
          const borderRightVal = $borderRight.attr('value');
          const borderBottomVal = $borderBottom.attr('value');
          const borderLeftVal = $borderLeft.attr('value');
          if (borderTopVal == borderLeftVal && borderTopVal == borderRightVal && borderTopVal == borderBottomVal) {
            $element.data('gfrangepicker').setOffBlock(borderTopVal);
          } else {
            $element.data('gfrangepicker').setBlock();
          }
        });

      $element.gfRangePicker({
        title: 'Border Thickness',
        onSelectedStop: function (value) {
          $borderTop.attr('value', value).val(value).trigger('value-change');
          $borderRight.attr('value', value).val(value).trigger('value-change');
          $borderBottom.attr('value', value).val(value).trigger('value-change');
          $borderLeft.attr('value', value).val(value).trigger('value-change');
        },
      });

      $element.off('input-change').on('input-change', function () {
        const value = $(this).val();
        $borderTop.attr('value', value).val(value).trigger('value-change').trigger('input-change');
        $borderRight.attr('value', value).val(value).trigger('value-change').trigger('input-change');
        $borderBottom.attr('value', value).val(value).trigger('value-change').trigger('input-change');
        $borderLeft.attr('value', value).val(value).trigger('value-change').trigger('input-change');
      });

      const borderTopVal = $borderTop.attr('value');
      const borderRightVal = $borderRight.attr('value');
      const borderBottomVal = $borderBottom.attr('value');
      const borderLeftVal = $borderLeft.attr('value');

      if (borderTopVal == borderLeftVal && borderTopVal == borderRightVal && borderTopVal == borderBottomVal) {
        $element.data('gfrangepicker').setOffBlock(borderTopVal);
      } else {
        $element.data('gfrangepicker').setBlock();
      }

      return false;
    };

    this.init();
  };
  jQuery.fn.gfBorderWidthAll = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfborderwidthall')) {
        const plugin = new jQuery.gfBorderWidthAll(this, options);
        jQuery(this).data('gfborderwidthall', plugin);
      }
    });
  };
})(jQuery);

(function (jQuery) {
  jQuery.gfBorderRadiusAll = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.refresh();
    };

    this.refresh = function () {
      const $dad = $element.parents('.columns');
      const $advanced = $dad.next('.columns-advanced');
      const $gfBorderRadius = $advanced.find('.gfBorderRadius');

      const $borderTopLeft = $gfBorderRadius.find('input[name="border-top-left-radius"]');
      const $borderTopRight = $gfBorderRadius.find('input[name="border-top-right-radius"]');
      const $borderBottomLeft = $gfBorderRadius.find('input[name="border-bottom-left-radius"]');
      const $borderBottomRight = $gfBorderRadius.find('input[name="border-bottom-right-radius"]');
      $borderTopLeft
        .add($borderTopRight)
        .add($borderBottomLeft)
        .add($borderBottomRight)
        .on('value-change', function () {
          const borderTopLeft = $borderTopLeft.attr('value');
          const borderTopRight = $borderTopRight.attr('value');
          const borderBottomLeft = $borderBottomLeft.attr('value');
          const borderBottomRight = $borderBottomRight.attr('value');
          if (
            borderTopLeft == borderTopRight &&
            borderTopLeft == borderBottomLeft &&
            borderTopLeft == borderBottomRight
          ) {
            $element.data('gfrangepicker').setOffBlock(borderTopLeft);
          } else {
            $element.data('gfrangepicker').setBlock();
          }
        });

      $element.gfRangePicker({
        title: 'Border Radius',
        onSelectedStop: function (value) {
          $borderTopLeft.attr('value', value).val(value).trigger('value-change');
          $borderTopRight.attr('value', value).val(value).trigger('value-change');
          $borderBottomLeft.attr('value', value).val(value).trigger('value-change');
          $borderBottomRight.attr('value', value).val(value).trigger('value-change');
        },
      });

      const borderTopLeft = $borderTopLeft.attr('value');
      const borderTopRight = $borderTopRight.attr('value');
      const borderBottomLeft = $borderBottomLeft.attr('value');
      const borderBottomRight = $borderBottomRight.attr('value');
      if (borderTopLeft == borderTopRight && borderTopLeft == borderBottomLeft && borderTopLeft == borderBottomRight) {
        $element.data('gfrangepicker').setOffBlock(borderTopLeft);
      } else {
        $element.data('gfrangepicker').setBlock();
      }
    };

    this.init();
  };
  jQuery.fn.gfBorderRadiusAll = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfborderradiusall')) {
        const plugin = new jQuery.gfBorderRadiusAll(this, options);
        jQuery(this).data('gfborderradiusall', plugin);
      }
    });
  };
})(jQuery);
